import configurator from 'bookingbug-configurator-js';
import Splash from './pages/Splash/Splash.page';
import Item from './pages/Item/Item.page';
import CheckIn from './pages/CheckIn/CheckIn.page';
import CheckInConfirmation from './pages/CheckInConfirmation/CheckInConfirmation.page';
import LocaleSelectorPage from './pages/LocaleSelector/LocaleSelector.page';

const routes = {
  LocaleSelector: {
    path: '/',
    exact: true,
    component: LocaleSelectorPage,
  },
  Splash: {
    path: '/welcome',
    exact: true,
    component: Splash,
    enter: (state) => (
      (configurator.getTranslatedLanguages().length > 1 && state.i18n.locales)
      || (configurator.getTranslatedLanguages().length === 1 && !state.i18n.locales) || (state.i18n.locales && state.i18n.locales.length === 1)
    ),
    get redirect() {
      return routes.LocaleSelector;
    },
  },
  Item: {
    path: '/item/:title',
    exact: true,
    component: Item,
  },
  CheckIn: {
    path: '/check-in',
    exact: true,
    component: CheckIn,
  },
  CheckInConfirmation: {
    path: '/confirmation',
    exact: true,
    component: CheckInConfirmation,
    get parent() { return routes.CheckIn; },
    enter: (state) => !!state.details,
    get redirect() { return routes.CheckIn; },
  },
};

export default routes;
